/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FoundationEnum = 1 | 2 | 3;

export const FoundationEnum = {
    NUMBER_1: 1 as FoundationEnum,
    NUMBER_2: 2 as FoundationEnum,
    NUMBER_3: 3 as FoundationEnum
};

